var _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrokenHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA5A47",
    d: "M49.5657,15.6092c-4.3218,0-8.187,2.3611-10.1887,6.1814L36,29.678l7,6.0169l-6,8.4238L42,51 l-3.5852,9.1622l20.462-26.2371c1.4419-1.9653,2.2134-4.3222,2.2134-6.7934C61.0902,20.7782,55.9202,15.6092,49.5657,15.6092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA5A47",
    d: "M37.0994,50.9843l-5.0534-6.9615l5.9387-8.0457l-7.0457-5.9463c0,0,1.6215-7.5485,1.455-7.8939 c-1.9444-4.0263-5.9185-6.5278-10.3711-6.5278c-6.3535,0-11.5225,5.169-11.5225,11.5225c0,2.1167,0.5776,4.185,1.6714,5.9814 l0.6602,0.9737l20.4624,26.2299l0.3502-0.449L37.0994,50.9843z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M49.5657,15.6092c-4.3218,0-8.187,2.3611-10.1887,6.1814L36,29.678l7,6.0169l-6,8.4238L42,51l-3.5852,9.1622l20.462-26.2371 c1.4419-1.9653,2.2134-4.3222,2.2134-6.7934C61.0902,20.7782,55.9202,15.6092,49.5657,15.6092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M37.0994,50.9843l-5.0534-6.9615l5.9387-8.0457 l-7.0457-5.9463c0,0,1.6215-7.5485,1.455-7.8939c-1.9444-4.0263-5.9185-6.5278-10.3711-6.5278 c-6.3535,0-11.5225,5.169-11.5225,11.5225c0,2.1167,0.5776,4.185,1.6714,5.9814l0.6602,0.9737l20.4624,26.2299l0.3502-0.449 L37.0994,50.9843z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenHeart);
export default __webpack_public_path__ + "static/media/broken-heart.03f9a19b9c36fe37269941908768c10a.svg";
export { ForwardRef as ReactComponent };